import React, { HTMLAttributes, ReactNode, useState } from 'react';

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  subtitle?: ReactNode;
  icon?: ReactNode;
  collapsible?: boolean;
  defaultOpen?: boolean;
}

export const Card: React.FC<CardProps> = ({
  title,
  subtitle,
  icon,
  collapsible = false,
  defaultOpen = true,
  children,
  className = '',
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const combinedClassName = `acc ${collapsible && isOpen ? 'open' : ''} ${className}`.trim();

  return (
    <div className={combinedClassName} {...props}>
      {title && (
        <div
          className="acc-head"
          onClick={() => collapsible && setIsOpen(!isOpen)}
          style={{ cursor: collapsible ? 'pointer' : 'default' }}
        >
          <div className="acc-title">
            {icon && (
              <div className="ai">
                {icon}
              </div>
            )}
            <div>
              {title}
              {subtitle && <div className="acc-meta">{subtitle}</div>}
            </div>
          </div>
          {collapsible && (
            <svg
              className="chev"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M9 18l6-6-6-6" />
            </svg>
          )}
        </div>
      )}
      <div className="acc-body" style={{ display: !collapsible || isOpen ? 'block' : 'none' }}>
        {children}
      </div>
    </div>
  );
};
